// extracted by mini-css-extract-plugin
export default {"group":"ElevationChart--group--28WMp","infoBox":"ElevationChart--infoBox--IP-ti","value":"ElevationChart--value--eK+Z5"};